const ValidateTypeConst = {
  REGULAR: 1,
  SQL: 2,
  NO_VALIDATE: 3,
  NOT_NULL: 4,
  IS_NUMBER: 5,
};
export default ValidateTypeConst;
